// 知识库
import request from "@/utils/interceptor.js";

const knowledgeGroupApi = {
  // 获取分组列表
  getGroupList(params) {
    return request({ url: "/api/pas/knowledge-base-group", method: "get", params });
  },
  // 新增分组
  addGroup(data) {
    return request({ url: "/api/pas/knowledge-base-group", method: "post", data });
  },
  // 删除分组
  deleteGroup(id) {
    return request({
      url: `/api/pas/knowledge-base-group/${id}`,
      method: "delete",
    });
  },
  // 修改分组
  editGroup(data) {
    return request({
      url: `/api/pas/knowledge-base-group/${data.id}`,
      method: "put",
      data,
    });
  },
  // 获取知识库知识列表
  getKnowledgeList(params) {
    return request({ url: "/api/pas/knowledge-base", method: "get", params });
  },
  // 新增知识
  addKnowledge(data) {
    return request({ url: "/api/pas/knowledge-base", method: "post", data });
  },
  // 删除知识
  deleteKnowledge(id) {
    return request({ url: `/api/pas/knowledge-base/${id}`, method: "delete" });
  },
  // 编辑知识
  editKnowledge(data) {
    return request({
      url: `/api/pas/knowledge-base/${data.id}`,
      method: "put",
      data,
    });
  },
};

export default knowledgeGroupApi;
